<template>
  <div class="component rotate-device">
    <img src="/img/svg/rotate.svg" alt="Rotate device icon">
  </div>
</template>

<script>
export default {
  name: 'RotateDevice',
};
</script>

<style lang="scss" scoped>
.rotate-device {
  @include full(true);

  background-color: $color-yellow;
  background-image: url('/img/misc/bg-repeater.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  z-index: 999;

  display: none;
  align-items: center;
  justify-content: center;

  @include mq($until: ipadL, $and: '(orientation: landscape)') {
    display: flex;
  }

  @include mq($and: $is-not-touch-device) {
    display: none;
  }

  img {
    width: 30vh;
    height: 30vh;
    animation-name: rotate;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;

    @keyframes rotate {
      0% { transform: rotate(0deg) }
      100% { transform: rotate(360deg) }
    }
  }
}
</style>
